import * as actionType from "./contactActionType";

const initialState = {
  isLoading: false,
  isSaved: false
};

export const contactReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CONTACT_CREATE:
            return {
                ...state,
                isLoading: true,
                isSaved: false
            };
        case actionType.CONTACT_CREATE_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.CONTACT_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true
            };
        default:
            return state;
    }
}